import React from 'react';
import { observer } from 'mobx-react';
import { clientStore } from 'apps/client/app';
import { ComponentBaseProps } from 'types';
import { useDesktopCompatibility } from 'hooks/useDesktopCompatible';
import {
  SpacingToAvoidFrameMobile,
  SpacingToAvoidFrameDesktop,
} from './spacingToAvoidFrame.styled';

type SpacingToAvoidFrameProps = {
  active?: boolean;
  withoutLeftSpacing?: boolean;
  children?: React.ReactNode;
  desktopMode?: boolean;
} & ComponentBaseProps;

const SpacingToAvoidFrame = observer(
  ({
    active,
    withoutLeftSpacing,
    children,
    style = {},
    desktopMode,
  }: SpacingToAvoidFrameProps) => {
    const SpacingToAvoidFrameComponent = clientStore.isMobile
      ? SpacingToAvoidFrameMobile
      : SpacingToAvoidFrameDesktop;

    const compatibleWithTab = useDesktopCompatibility({
      feature: 'tab',
    });

    return (
      <SpacingToAvoidFrameComponent
        active={active}
        hidePaddingTop={desktopMode && compatibleWithTab}
        style={{
          overflow: 'scroll',
          ...style,
        }}
        withoutLeftSpacing={withoutLeftSpacing}
      >
        {children}
      </SpacingToAvoidFrameComponent>
    );
  },
);

export default SpacingToAvoidFrame;
